import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-white py-20 px-4" data-id="element-56">
      <div className="max-w-3xl mx-auto text-center border-4 border-gold-400 rounded-3xl p-8 md:p-12 shadow-xl" data-id="element-57">
        <div className="flex justify-center mb-6" data-id="element-58">
          <ShieldCheck className="w-24 h-24 text-gold-500" data-id="element-59" />
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-forest-900 mb-8" data-id="element-60">
          GARANTÍA TOTAL DE 7 DÍAS
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-forest-800 leading-relaxed max-w-2xl mx-auto" data-id="element-61">
          <p data-id="element-62">
            Aplicá el Protocolo. Hacé la primera infusión. Seguí el semáforo de
            compras.
          </p>
          <p data-id="element-63">Si en 7 días no sentís la diferencia...</p>
          <p className="font-bold text-2xl text-forest-900" data-id="element-64">
            Te devolvemos el 100%.
          </p>
          <p data-id="element-65">Sin formularios. Sin excusas. Un mail es suficiente.</p>
          <div className="mt-8 pt-6 border-t border-forest-100" data-id="element-66">
            <p className="text-2xl font-bold text-solution italic" data-id="element-67">
              "Nuestro riesgo. Tu resultado."
            </p>
          </div>
        </div>
      </div>
    </section>;
}